/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Statsguestsamongthem3Inputs */

const en_statsguestsamongthem3 = /** @type {(inputs: Statsguestsamongthem3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} of them guests`)
};

const de_statsguestsamongthem3 = /** @type {(inputs: Statsguestsamongthem3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`davon ${i?.count} Gäste`)
};

/**
* | output |
* | --- |
* | "{count} of them guests" |
*
* @param {Statsguestsamongthem3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsguestsamongthem3 = /** @type {((inputs: Statsguestsamongthem3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsguestsamongthem3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsguestsamongthem3(inputs)
	return de_statsguestsamongthem3(inputs)
});
export { statsguestsamongthem3 as "statsGuestsAmongThem" }